import axios from "axios";


import Chatbutton from '../components/chatbutton'
import '../styles/chatbutton.css'
import '../styles/allusers.css'

import React from "react";



export default class Allusers extends React.Component {
  state = {
    posts: []
  }

  componentDidMount() {
    axios.get(`https://shoppee-clone.herokuapp.com/users`)
      .then(res => {
        const posts = res.data;
        this.setState({ posts });
      })
  }

  render() {

    return (

      <div>


        {this.state.posts.map(post => <div className="container-fluid"><div className="card" id="cardproduct1"><br />
          <label className="card-title">Username:</label><span id="texttitle">&nbsp;&nbsp;{post.username}
            <div className="card-body"><label id="labelcolor">password:</label><span id="textcol">{post.password}</span><br />
            </div></span></div></div>)}
        <Chatbutton />

      </div>
    )
  }
}

